<div class="excel-style-container">

    <ng-container *ngIf="!siteId">
        <div class="content-container empty-image">
            <mat-icon svgIcon="empty-icon" class="empty-icon"></mat-icon>
            <div class="no-data">
                <h4>Please select site prior to add fine goals.</h4>
            </div>
        </div>
    </ng-container>

    <div class="table-content" *ngIf="!loading && siteId;">
        <table mat-table [dataSource]="dataSource" class="data mat-elevation-z1 excel-table">

            <ng-container matColumnDef="project">
                <th mat-header-cell *matHeaderCellDef> Project </th>
                <td mat-cell *matCellDef="let element"> {{element.project}} </td>
            </ng-container>

            <ng-container matColumnDef="utilization">
                <th mat-header-cell *matHeaderCellDef> Utilization </th>
                <td mat-cell *matCellDef="let element"> {{element.utilization}} </td>
            </ng-container>

            <ng-container matColumnDef="utilizationGoal">
                <th mat-header-cell *matHeaderCellDef> Utilization Goal (%)</th>
                <td mat-cell *matCellDef="let element">
                    <input matInput [(ngModel)]="element.utilizationGoal" type="number" min="0"
                        (change)="onInputChange()">
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>

        <mat-paginator pageSize="30" [pageSizeOptions]="[30, 40]" hidePageSize="true">
        </mat-paginator>

        <ng-container *ngIf="loading || tableLoading">
            <div class="loading-logo">
                <mat-spinner></mat-spinner>
            </div>
        </ng-container>
    </div>